(function ($) {
    $(document).ready(function() {

    // configure options
    const config = {
        user_id : 1,
        filters: {
            location: 79,
            parameter1: 28,
            parameter2: 24
        },
        init: function() {
            fetchResults();
        }
    }

    config.init();
    var correlationGraph;

    // configure data request for locations dropdown list
    const locationsRequest = {
        url: "sites/all/scripts/activeDataFilters.php",
        data: {
            table: "viewer.download_dropdown_locs",
            fields: ['stored', 'displayed'],
            drupal_user_switch: false,
            drupal_userid: config.user_id
        }
    }

    const locationsOptions = {
        container: "#location-select",
        valueIndex: 0,
        textIndex: 1,
        selectedValue: 79,
        onChange: function() {
            locationsOptions.selectedValue = locationDropdown.getValue();
            config.filters.location = locationsOptions.selectedValue;
            fetchResults();
        }
    }

    // configure options for parameters dropdown list
    const parametersOptions1 = {
        container: "#parameter1-select",
        valueIndex: 0,
        textIndex: 1,
        selectedValue: 28,
        onChange: function() {
            parametersOptions1.selectedValue = parameterDropdown1.getValue();
            config.filters.parameter1 = parametersOptions1.selectedValue;
            fetchResults();
        }
    }

    const parametersOptions2 = {
        container: "#parameter2-select",
        valueIndex: 0,
        textIndex: 1,
        selectedValue: 24,
        onChange: function() {
            parametersOptions2.selectedValue = parameterDropdown2.getValue();
            config.filters.parameter2 = parametersOptions2.selectedValue;
            fetchResults();

        }
    }

    // configure data request for parameters dropdown list
    var parametersRequest = {
        url: "sites/all/scripts/activeDataFilters.php",
        data: {
            table: "viewer.list_parameters_dropdown_simple",
            fields: ['stored', 'displayed'],
            drupal_user_switch: false,
            drupal_userid: config.user_id
        }
    }

    // create dropdowns
    var locationDropdown = new Dropdown(locationsOptions, locationsRequest);
    var parameterDropdown1 = new Dropdown(parametersOptions1, parametersRequest);
    var parameterDropdown2 = new Dropdown(parametersOptions2, parametersRequest);

    function fetchResults() {
        var resultsPromise = loadGraphData(config.filters);
        $.when(resultsPromise).done(function(data) {
            var response = JSON.parse(data);
            const params = [...new Set(response.map( d => d.parameterid))];
            if (response && params.length > 1) {
                $( '#correlation-graph' ).empty();
                drawGraph(response);
            } else {
                $( '#correlation-graph' ).empty().html('<h3 class="text-center" style="color: #F44336;">No data for the selected filters</h3>')
            }
        })
    }

    function loadGraphData(filters) {
        return $.ajax({
            url: "sites/all/scripts/correlation.php",
            data: {
                table: "viewer.results_simple",
                fields: ["rdate", "locationid", "location_name", "parameterid", "parameter", "rvalue_converted", "unit_name"],
                location: filters.location,
                parameter1: filters.parameter1,
                parameter2: filters.parameter2,
                sort: 1
            }
        })
    }

    function unique(data) {
        var series = [];
        var keys = Object.keys(data[0]);
        for (var i = 0; i < keys.length; i++) {
            series.push({"name": keys[i], "values": []})
        }
        for (var i = 0; i < series.length; i++) {
            for (var j = 0; j < data.length; j++) {
                if (series[i].values.indexOf(data[j][series[i].name]) == -1) {
                    series[i].values.push(data[j][series[i].name]);
                }
            }
        }
        return series
    }

    function drawGraph(data) {
        // remove svg is exists
        d3.select("#correlation-graph svg").remove();

        var graphData = data,
            series = unique(graphData);

        var dataArray = [];
        var parameter1Array = [];
        var parameter2Array = [];

        var containerWidth = $( '#correlation-graph' ).width();
        var containerHeight = containerWidth * .6;

        // set the dimensions and margins of the graph
        var margin = {top: 20, right: 20, bottom: 60, left: 50},
            width = containerWidth - margin.left - margin.right,
            height = containerHeight - margin.top - margin.bottom;

        // set the ranges
        var x = d3.scaleLinear().range([0, width]);
        var y = d3.scaleLinear().range([height, 0]);

        // append the svg obgect to the body of the page
        // appends a 'group' element to 'svg'
        // moves the 'group' element to the top left margin
        var svg = d3.select("#correlation-graph").append("svg")
            .attr("width", width + margin.left + margin.right)
            .attr("height", height + margin.top + margin.bottom);

        // appends a 'group' element to 'svg'
          // moves the 'group' element to the top left margin
          var g = svg.append("g")
            .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

        // step 1: create 2 arrays, one for each parameter
        function step1() {
            var selectedParams = [+parametersOptions1.selectedValue, +parametersOptions2.selectedValue];

            for (var i = 0; i < selectedParams.length; i++) {
                var s = selectedParams[i];
                for (var j = 0; j < data.length; j++) {
                    var d  = data[j];
                    if (s == d.parameterid && i == 0) {
                        var recordObj = {
                            locationid: +d.locationid,
                            locationName: d.location_name,
                            rvalue: +d.rvalue_converted,
                            parameter: +d.parameterid,
                            parameterName: d.parameter,
                            units: d.unit_name,
                            rdate: d.rdate
                        }
                        parameter1Array.push(recordObj);
                    } else if (s == d.parameterid && i == 1) {
                        var recordObj = {
                            locationid: +d.locationid,
                            locationName: d.location_name,
                            rvalue: +d.rvalue_converted,
                            parameter: +d.parameterid,
                            parameterName: d.parameter,
                            units: d.unit_name,
                            rdate: d.rdate
                        }
                        parameter2Array.push(recordObj);
                    }
                }
            }
            // combine two arrays
            dataArray.push(parameter1Array, parameter2Array);
        }

        // step 2: create unique copies of each array, with values
        // collected on same date for a given parameter averaged
        function step2() {
            function uniqueDates(data) {
                var dateSeries = [];
                for (var i = 0; i < data.length; i++) {
                    if (dateSeries.indexOf(data[i].rdate) == -1) {
                        dateSeries.push({"rdate": data[i].rdate, "values": [], "parameterid": data[i].parameter, "parameterName": data[i].parameterName, "locationid": data[i].locationid, "locationName": data[i].locationName, "units": data[i].units});
                    }
                }
                return dateSeries
            }

            var dates = [uniqueDates(dataArray[0]), uniqueDates(dataArray[1])];

            // loop through first parameter array
            for (var i = 0; i < dataArray[0].length; i++) {
                for (var j = 0; j < dates[0].length; j++) {
                    if(dates[0][j].rdate == dataArray[0][i].rdate) {
                        dates[0][j].values.push(dataArray[0][i].rvalue);
                    }
                }
            }

            // loop through second parameter array
            for (var i = 0; i < dataArray[1].length; i++) {
                for (var j = 0; j < dates[1].length; j++) {
                    if(dates[1][j].rdate == dataArray[1][i].rdate) {
                        dates[1][j].values.push(dataArray[1][i].rvalue)
                    }
                }
            }

            // average values if more found for same date
            for (var i = 0; i < dates.length; i++) {
                for (var j = 0; j < dates[i].length; j++) {
                    if (dates[i][j].values.length > 0 && dates[i][j].values.length < 2) {
                        dates[i][j].fvalue = d3.mean(dates[i][j].values);
                    } else {
                        dates[i][j].fvalue = dates[i][j].values[0];
                    }
                }
            }

            return dates;
        }

        // compare unique arrays for each parameter against each other
        function step3(dates) {
            var finalArray = [];
            for (var i = 0; i < dates[0].length; i++) {
                for (var j = 0; j < dates[1].length; j++) {
                    if (dates[0][i].rdate == dates[1][j].rdate) {
                        var momentObj = moment(dates[0][i].rdate, "YYYY-MM-DD");
                        var rdateFormatted = momentObj.format("MM/DD/YYYY");
                        var recordObj = {
                            rdate: dates[0][i].rdate,
                            rdateFormatted: rdateFormatted,
                            locationid: dates[0][i].locationid,
                            locationName: dates[0][i].locationName,
                            parameter1: dates[0][i].parameterName,
                            parameter2: dates[1][j].parameterName,
                            units1: dates[0][i].units,
                            units2: dates[1][j].units,
                            value1: dates[0][i].fvalue,
                            value2: dates[1][j].fvalue
                        }
                        finalArray.push(recordObj);
                    }
                }
            }

            function returnValues(array, key) {
                var newArray = [];
                array.filter(function(d) {
                    newArray.push(d[key]);
                })
                return newArray;
            }

            function pearsonCorrelation(prefs, p1, p2) {
              var si = [];

              for (var key in prefs[p1]) {
                if (prefs[p2][key]) si.push(key);
              }

              var n = si.length;

              if (n == 0) return 0;

              var sum1 = 0;
              for (var i = 0; i < si.length; i++) sum1 += prefs[p1][si[i]];

              var sum2 = 0;
              for (var i = 0; i < si.length; i++) sum2 += prefs[p2][si[i]];

              var sum1Sq = 0;
              for (var i = 0; i < si.length; i++) {
                sum1Sq += Math.pow(prefs[p1][si[i]], 2);
              }

              var sum2Sq = 0;
              for (var i = 0; i < si.length; i++) {
                sum2Sq += Math.pow(prefs[p2][si[i]], 2);
              }

              var pSum = 0;
              for (var i = 0; i < si.length; i++) {
                pSum += prefs[p1][si[i]] * prefs[p2][si[i]];
              }

              var num = pSum - (sum1 * sum2 / n);
              var den = Math.sqrt((sum1Sq - Math.pow(sum1, 2) / n) *
                  (sum2Sq - Math.pow(sum2, 2) / n));

              if (den == 0) return 0;

              return num / den;
            }

            var xValues = returnValues(finalArray, "value1");
            var yValues = returnValues(finalArray, "value2");
            var n = finalArray.length;
            var x_mean = d3.mean(xValues);
            var y_mean = d3.mean(yValues);
            var term1 = 0;
            var term2 = 0;

            // calculate coefficients
            var xr = 0;
            var yr = 0;
            for (i = 0; i < xValues.length; i++) {
                xr = xValues[i] - x_mean;
                yr = yValues[i] - y_mean;
                term1 += xr * yr;
                term2 += xr * xr;

            }
            var b1 = term1 / term2;
            var b0 = y_mean - (b1 * x_mean);
            // perform regression

            let yhat = [];
            // fit line using coeffs
            for (i = 0; i < xValues.length; i++) {
                yhat.push(b0 + (xValues[i] * b1));
            }

            for (i = 0; i < yValues.length; i++) {
                finalArray[i].yhat = yhat[i];
            }

            $( '#trendline-equation-value' ).html('y = ' + Number(b1).toFixed(2) + "x" + " + " + Number(b0).toFixed(2));
            $( '#pearsons-r-value' ).html(Number(pearsonCorrelation([xValues,yValues],0,1)).toFixed(2));
            return finalArray
        }

        function crunchData() {
            step1();
            var uniqueDates = step2();
            var finalArray = step3(uniqueDates)
            return finalArray;
        };

        var finalData = crunchData();

        // create the color scale to display graph series
        var color = d3.scaleOrdinal(d3.schemeCategory10);

        x.domain(d3.extent(finalData, function(d) { return d.value1}));
        y.domain(d3.extent(finalData, function(d) { return d.value2}));

        // define the line
        var line = d3.line()
            .x(function(d) { return x(d.value1); })
            .y(function(d) { return y(d.yhat); });

        // add the scatterplot
        g.selectAll("dot")
                .data(finalData)
            .enter().append("circle")
                .attr("r", 4)
                .attr("cx", function(d) { return x(d.value1); })
                .attr("cy", function(d) { return y(d.value2); })
                .style("fill", color()) // dot fill color
                .style("stroke", "#222")
                .on("mouseover", function(d) { //define mouseover behavior
                        d3.select(this) // increase dot size and stroke width on hover
                            .attr("r", 6)
                            .style("opacity", 0.7)
                            .style("stroke-width", 2)
                            .style("stroke", "#000")
                        var t = d3.select(this.parentNode).attr("transform");
                             t = t.substring(t.indexOf("(")+1, t.indexOf(")")).split(",");
                        // set tooltip text
                           d3.select('#active-location').html(d.locationName);
                           d3.select('#active-date').html(d.rdateFormatted);
                           d3.select('#active-parameter-1-header').html(d.parameter1);
                           d3.select('#active-parameter-1').html(+d.value1.toFixed(2) + " " + d.units1);
                           d3.select('#active-parameter-2-header').html(d.parameter2);
                           d3.select('#active-parameter-2').html(+d.value2.toFixed(2) + " " + d.units2);
                       })
                .on("mouseout", function(d) { //define mouseout behavior
                         d3.select(this) // reset dot style
                             .attr("r", 4)
                            .style("opacity", 1)
                            .style("stroke-width", 1)
                            .style("stroke", "#222")
                       });

        g.append("path")
            .datum(finalData)
            .attr("class", "line")
            .attr("d", line);

        // add the x-axis
        g.append("g")
            .attr("transform", "translate(0," + height + ")")
            .call(d3.axisBottom(x))
                .append("text")
                .attr("fill", "#000")
                .attr("x", width/2)
                .attr("dx", "0.71em")
                .attr("dy", "3.5em")
                .attr("class", "axis-label")
                .style("text-anchor", "end")
                .text(finalData[0].parameter1 + " (" + finalData[0].units1 + ")")

        // Add the Y Axis
          g.append("g")
             .call(d3.axisLeft(y))
                 .append("text")
                .attr("fill", "#000")
                .attr("transform", "rotate(-90)")
                .attr("x", 0)
                .attr("y", 6)
                .attr("dy", "0.71em")
                .attr("class", "axis-label")
                .style("text-anchor", "end")
                .text(finalData[0].parameter2 + " (" + finalData[0].units2 + ")");

    }
    })
    })(jQuery);